/**
 * Deps Command Group
 * Quản lý dependencies trong project
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { createDepsCheckCommand } from './check.js';
import { createDepsUpgradeCommand } from './upgrade.js';

function showDepsHelp(): void {
    console.log(chalk.bold.cyan('📦 jai1 deps') + chalk.dim(' - Quản lý dependencies trong project'));
    console.log();
    console.log(chalk.bold('Các lệnh:'));
    console.log(`  ${chalk.cyan('check')}     Kiểm tra các packages cần upgrade`);
    console.log(`  ${chalk.cyan('upgrade')}   Nâng cấp dependencies lên phiên bản mới nhất`);
    console.log();
    console.log(chalk.bold('Hỗ trợ:'));
    console.log(chalk.dim('  • Node.js (npm, pnpm, yarn, bun)'));
    console.log(chalk.dim('  • PHP/Composer (với bảo vệ Laravel major version)'));
    console.log(chalk.dim('  • Python (pip, pipenv)'));
    console.log();
    console.log(chalk.bold('Ví dụ:'));
    console.log(chalk.dim('  $ jai1 deps check'));
    console.log(chalk.dim('  $ jai1 deps upgrade'));
    console.log(chalk.dim('  $ jai1 deps upgrade --all'));
    console.log();
    console.log(chalk.dim('Chạy "jai1 deps <lệnh> --help" để xem chi tiết'));
}

export function createDepsCommand(): Command {
    const depsCommand = new Command('deps')
        .description('Quản lý dependencies trong project')
        .action(() => {
            showDepsHelp();
        });

    // Register subcommands
    depsCommand.addCommand(createDepsCheckCommand());
    depsCommand.addCommand(createDepsUpgradeCommand());

    return depsCommand;
}
